import {
  Button,
  CardHeader,
  DataGrid,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
} from "..";
import { formatPrice } from "../../utils";

const OrdemCompraDialog = ({
  openDialog,
  setOpenDialog,
  itens,
  produtos,
  setProdutos
}) => {

  const colunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 200,
    },
    {
      field: "descricao",
      headerName: "Descrição",
      flex: 700,
    },
    {
      field: "quantidade",
      headerName: "Quantidade",
      flex: 350,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => Number.isInteger(parseFloat(params.value)) 
        ? params.value
        : params.value.toFixed(3).replace(".", ",")
    },
    {
      field: "precoVenda",
      headerName: "Preço Venda (R$)",
      flex: 350,
      headerAlign: 'right',
      align: 'right',
      valueGetter: (params) => {
        const value = params.value ?? params.row.valor ?? params.row.valorUnitario;
        return value ? formatPrice(parseFloat(value), false) : "";
      }
    },
    {
      field: "ordemCompra",
      headerName: "Ordem Compra",
      flex: 400,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        return (
          <div key={params.row.id}>
            <TextField
              id="ordemCompra"
              name="ordemCompra"
              type="text"
              variant="standard"
              value={params.value}
              fullWidth
              onChange={(event) => 
                handleNumericInputChange(params.row.id, params.row.produtoId, event)
              }
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <i className="ph-fill ph-pencil" style={{ fontSize: 20 }}></i>
                ),
                sx: {
                  '& input': {
                    fontFamily: "'Montserrat', sans-serif !important",
                    fontSize: '15px',
                  }
                }
              }}
            />
          </div>
        );
      },
    },
    {
      field: "numeroItem",
      headerName: "Nº Item",
      flex: 350,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        return (
          <div key={params.row.id}>
            <TextField
              id="numeroItem"
              name="numeroItem"
              type="text"
              variant="standard"
              value={params.value}
              fullWidth
              onChange={(event) => 
                handleNumericInputChange(params.row.id, params.row.produtoId, event)
              }
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <i className="ph-fill ph-pencil" style={{ fontSize: 20 }}></i>
                ),
                sx: {
                  '& input': {
                    fontFamily: "'Montserrat', sans-serif !important",
                    fontSize: '15px'
                  }
                }
              }}
            />
          </div>
        );
      },
    },
  ];

  const handleNumericInputChange = (id, produtoId, event) => {
    const { name, value } = event.target;
    const numericValue = value.replace(/[^0-9]/g, "");
    let qtdLimiteDigitos = 15;
    if (name === "numeroItem") {
      qtdLimiteDigitos = 6;
    }
    if (value.length <= qtdLimiteDigitos) {
      const item = itens.find((item) => item.produtoId === produtoId);
      item.setInputAttribute(name, value);

      setProdutos((prevState) => prevState.map((produto) => 
        id === produto.id 
          ? { ...produto, [name]: numericValue } 
          : produto
      ));
    }
  }

  const handleCloseDialog = () => {
    setOpenDialog(false);
  }

  return (
    <Dialog fullWidth maxWidth={"lg"} open={openDialog} onClose={handleCloseDialog}>
      <CardHeader title="Ordem de Compra" className="ms-2 mt-2" />
      <DialogContent>
        <DataGrid
          rows={produtos}
          columns={colunas}
          rowCount={produtos.length}
          disableAcoes
        />
      </DialogContent>
      <DialogActions 
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          mx: 2,
        }}
      >
        <Button
          onClick={handleCloseDialog}
          color="primary"
          variant="contained"
        >
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OrdemCompraDialog;
